/**
 * Display service error
 * @param {Element} serviceErrorContainer - Service error container
 * @param {String} errorMsg - Service error to be displayed
 */
const displayServiceError = (serviceErrorContainer, errorMsg) => {
    if (!serviceErrorContainer) { return; }

    const errorMsgWrapper = serviceErrorContainer.querySelector(".ct-service-error-message");

    errorMsgWrapper.textContent = errorMsg;

    //GTM logic - Start
    document.dispatchEvent(new CustomEvent("dataLayer.messagesEvents", {
        detail: {
            "success": false,
            "messageContent": errorMsg
        }
    }));
    //GTM logic - End
    
    serviceErrorContainer.classList.remove("d-none");
};

/**
 * Display service error
 * @param {Element} serviceErrorContainer - Service error container
 * @param {String} errorMsg - Service error to be displayed
 */
const displayHtmlServiceError = (serviceErrorContainer, errorMsg) => {
    if (!serviceErrorContainer) { return; }

    const errorMsgWrapper = serviceErrorContainer.querySelector(".ct-service-error-message");

    errorMsgWrapper.innerHTML = errorMsg;

    //GTM logic - Start
    document.dispatchEvent(new CustomEvent("dataLayer.messagesEvents", {
        detail: {
            "success": false,
            "messageContent": errorMsg
        }
    }));
    //GTM logic - End
    
    serviceErrorContainer.classList.remove("d-none");
};

/**
 * Hide service error
 * @param {Element} serviceErrorContainer - Service error container
 */
const hideServiceError = serviceErrorContainer => {
    if (!serviceErrorContainer) { return; }

    serviceErrorContainer.classList.add("d-none");
};

export { displayServiceError, hideServiceError, displayHtmlServiceError };
